import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetMerchantMonthlyLimit } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const merchantMonthlyLimit = createAsyncThunk('get/merchantMonthlyLimit', GetMerchantMonthlyLimit);

export const MerchantMonthlyLimitSlice = createSlice({
	name: 'merchantMonthlyLimit',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[merchantMonthlyLimit.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[merchantMonthlyLimit.rejected.toString()]: setAPIError,
		[merchantMonthlyLimit.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;
			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload?.data ?? payload;
		},
	},
});

interface IStates {
	[MerchantMonthlyLimitSlice.name]: ReturnType<typeof MerchantMonthlyLimitSlice.reducer>;
}

export const merchantMonthlyLimitSelector = (state: IStates): any => {
	return state[MerchantMonthlyLimitSlice.name] || {};
};

export const useMerchantMonthlyLimit = (): any => useSelector(merchantMonthlyLimitSelector);

export const fetchMerchantMonthlyLimit =
	() =>
	async (dispatch: IDispatcherType): Promise<void> =>
		await dispatch(merchantMonthlyLimit());

export const resetMerchantMonthlyLimit =
	() =>
	async (dispatch: IDispatcherType): Promise<void> =>
		await dispatch(MerchantMonthlyLimitSlice.actions.RESET());
